import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'
import _imports_1 from '@/assets/img/received.svg'


const _hoisted_1 = { class: "genericPadding hasHeader bgWhite" }
const _hoisted_2 = { class: "header withShadow d-flex aling-items-center justify-content-between py-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "sideContainer" }, null, -1)
const _hoisted_5 = { class: "masonry-with-columns" }
const _hoisted_6 = { class: "maxDesktopContainer" }
const _hoisted_7 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_swiper_slides = _resolveComponent("swiper-slides")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", {
          class: "sideContainer",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
        }, [
          _hoisted_3
        ]),
        _createVNode("span", null, [
          _createTextVNode(_toDisplayString(_ctx.title) + " - ", 1),
          _createVNode(_component_localized_text, {
            localizedKey: "app_gallery",
            text: "Gallery",
            class: "text-uppercase"
          })
        ]),
        _hoisted_4
      ]),
      _createVNode("div", _hoisted_5, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.gallery, (image, indice) => {
          return (_openBlock(), _createBlock("div", {
            class: "imageContainer",
            key: indice,
            onClick: ($event: any) => (_ctx.selectImage(indice))
          }, [
            _createVNode("img", {
              src: image,
              class: "w-100"
            }, null, 8, ["src"])
          ], 8, ["onClick"]))
        }), 128))
      ])
    ]),
    _createVNode("div", {
      class: ["swiperModal", _ctx.showSwiper ? 'active' : '']
    }, [
      _createVNode("div", _hoisted_6, [
        _createVNode("div", {
          class: "text-end mb-3",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showSwiper = false))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "app_close",
            text: "Close",
            class: "text-uppercase white"
          })
        ]),
        (_ctx.showSwiper)
          ? (_openBlock(), _createBlock(_component_swiper_slides, {
              class: "h-100",
              "slide-index": _ctx.localIndex,
              key: 'swiper_' + _ctx.localIndex
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.gallery, (item, i) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "swiper-slide",
                    key: i
                  }, [
                    _createVNode("div", null, [
                      _createVNode("img", {
                        class: "w-100 d-block",
                        src: item
                      }, null, 8, ["src"]),
                      _createVNode("div", {
                        class: "openBlanket mt-3",
                        onClick: ($event: any) => (_ctx.$store.state.openBlank(item))
                      }, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "app_apri",
                          text: "Apri",
                          class: "'text-uppercase black me-2'"
                        }),
                        _hoisted_7
                      ], 8, ["onClick"])
                    ])
                  ]))
                }), 128))
              ]),
              _: 1
            }, 8, ["slide-index"]))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ], 64))
}